"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoDetail = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var react_1 = tslib_1.__importDefault(require("react"));
var react_sticky_1 = require("react-sticky");
var LeftRailHeader_1 = require("../../Article/LeftRailHeader/LeftRailHeader");
var RateThis_1 = require("../../RateThis/RateThis");
var BrightcoveVideo_1 = require("../BrightcoveVideo");
var CanSocialShare_1 = require("./CanSocialShare");
var VideoTag_1 = require("./VideoTag");
require("./styles.less");
var VideoDetail = /** @class */ (function (_super) {
    tslib_1.__extends(VideoDetail, _super);
    function VideoDetail(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            width: window.innerWidth,
            isSticky: false,
        };
        _this.boundedUpdateDimensions = _this.updateDimensions.bind(_this);
        return _this;
    }
    VideoDetail.prototype.updateDimensions = function () {
        this.setState({
            width: window.innerWidth,
        });
    };
    VideoDetail.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.boundedUpdateDimensions);
    };
    VideoDetail.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.boundedUpdateDimensions);
    };
    VideoDetail.prototype.renderBrightcoveVideo = function (videoPageStore, videoId, image) {
        if (!videoId) {
            return null;
        }
        return (react_1.default.createElement(BrightcoveVideo_1.BrightcoveVideo, { videoId: videoId, videoPageStore: videoPageStore, image: image }));
    };
    VideoDetail.prototype.renderHeader = function (card) {
        return (react_1.default.createElement("div", { className: "m-green-section-video-detail__header" },
            react_1.default.createElement(LeftRailHeader_1.LeftRailHeader, { homepageUrl: this.props.homepageUrl, date: card.issueDate, issues: card.issues, subscribeLink: this.props.subscribeLink })));
    };
    VideoDetail.prototype.renderVideoPart = function (card) {
        var title = this.getCardTitle(card);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderBrightcoveVideo(this.props.videoPageStore, card.video.identifier, card.image),
            react_1.default.createElement("div", { className: "m-green-section-video-detail__content" },
                this.renderTitle(title),
                react_1.default.createElement("div", { className: "m-green-section-video-detail__social" },
                    react_1.default.createElement(VideoTag_1.VideoTag, tslib_1.__assign({}, card.pillarTag)),
                    react_1.default.createElement(CanSocialShare_1.CanSocialShare, null)),
                react_1.default.createElement("div", { className: "m-green-section-video-detail__description" }, card.description)),
            react_1.default.createElement(RateThis_1.RateThis, { title: "Rate This Video", videoPage: true })));
    };
    VideoDetail.prototype.renderTitle = function (title) {
        return (react_1.default.createElement("h1", { className: "m-green-section-video-detail__title", dangerouslySetInnerHTML: { __html: title || '' } }));
    };
    VideoDetail.prototype.getCardTitle = function (card) {
        return card.richTitle ? card.richTitle : card.title;
    };
    VideoDetail.prototype.render = function () {
        var _this = this;
        var card = this.props.videoPageStore.activeCard;
        if (!card) {
            return null;
        }
        if (this.state.width < 1023) {
            return (react_1.default.createElement("div", { className: "m-green-section-video-detail" },
                this.renderHeader(card),
                this.renderVideoPart(card)));
        }
        // @ts-ignore
        return (react_1.default.createElement(react_sticky_1.StickyContainer, { className: "container relative" },
            react_1.default.createElement("div", { className: "m-green-section-video-detail" },
                this.renderHeader(card),
                react_1.default.createElement(react_sticky_1.Sticky, { topOffset: -139, onStickyStateChange: function (value) {
                        return _this.setState({
                            isSticky: value,
                        });
                    } },
                    react_1.default.createElement("div", { style: { paddingTop: this.state.isSticky ? 139 : 0 }, className: "sticky-z-index" }, this.renderVideoPart(card))))));
    };
    VideoDetail = tslib_1.__decorate([
        mobx_react_1.observer,
        tslib_1.__metadata("design:paramtypes", [Object])
    ], VideoDetail);
    return VideoDetail;
}(react_1.default.Component));
exports.VideoDetail = VideoDetail;
